import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import db from '../../Utils/firebase';

const links = [
    {
        title: "Home",
        path: "/",
    },
    {
        title: "About",
        path: "/about",
    },
    {
        title: "Process",
        path: "/process",
    },
    {
        title: "Service",
        path: "/service",
    },
    {
        title: "Portfolio",
        path: "/portfolio",
    },
    {
        title: "Testimonial",
        path: "/testimonial",
    },
    {
        title: "Contact",
        path: "/contact",
    },
];

function Header() {
    const [displaySidenav, setDisplaySidenav] = useState(false);
    const [followOptions, setFollowOptions] = useState([])

    const handleClick = (e) => {
        setDisplaySidenav(!displaySidenav);
    };
    useEffect(() => {
        FetchFollowMeData()
    }, [])

    const FetchFollowMeData = async () => {

        await db.collection('root_collection').doc('some_document').collection('FollowMe').get()
            .then(querySnapshot => {
                console.log(querySnapshot)
                let arr = [];
                querySnapshot.docs.forEach(doc => {
                    arr.push(doc.data())
                });
                setFollowOptions(arr)
            });
    }

    return (
        <>
            <header className="app-header app-header-1">
                <ul className="header-menu">
                <NavLink to="/" exact>
                <img src="/assets/images/header/gk-logo.webp" alt="logo" />
                    <div className="name">Gopi Kachhadiya</div>
                    </NavLink>
                    <div className="menu-text">
                    {links.map((item, index) => (
                        <li key={index}>
                            <NavLink to={item.path} activeClassName="active" exact={item.path === '/'}>
                                <span className="anchor">{item.title}</span>
                            </NavLink>
                        </li>
                    ))}
                    <button type="button" className="button button-menu" onClick={(e) => handleClick(e)}>
                        <FaBars size={25} color="#139BFD"/>
                    </button>
                    </div>
                </ul>
            </header>
            <div className={`app-sidenav ${displaySidenav && "active"}`}>
                <div className="sidenav-menu">
                    <div>
                    <button type="button" className="button" onClick={(e) => handleClick(e)} text="close"></button>
                    </div>
                    
                    <ul className="sidenav-nav">
                        {links.map((item, index) => (
                            <li key={index} onClick={(e) => handleClick(e)}>
                                <NavLink to={item.path} activeClassName="active" exact={item.path === '/'}> 
                                    <span className="anchor">{item.title}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className="sidenav-links">
                        <div className="flex items-center gap-2" style={{ gap: "0.5rem", display: 'flex', alignItems: 'center', position:"relative", bottom:"1rem", right:"1rem" }}>
                            <span className="text-sm font-bold text-gray-200 tracking-wide uppercase">
                                Trusted Platform
                            </span>
                            <div 
                                className="bg-white/40"
                                style={{ width: "1rem", height: "1px" }}
                            />
                            <a href="https://www.upwork.com/freelancers/gopih" target="_blank" rel="noopener noreferrer" className="hover:scale-105 transition-transform flex items-center">
                                <img 
                                    src="/assets/images/intro/upwork.png" 
                                    alt="Upwork" 
                                    style={{ width: "4rem", height: "auto" }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <span className="sidenav-close" />
            </div>
        </>
    );
}

export default Header;
